import React, { useEffect, useState } from 'react';
import TextBox from './TextBox';
import TextEditor from './TextEditor';
import ExpandableContainer from './ExpandableContainer';
import DateTimePicker from './DateTimePicker';
import RatingPicker from './RatingPicker';


const CustomAddList = ({ label, buttonLabel, addList, isSocialList = false, isCourseList = false, isSkill = false, customListFormData, isProjectList = false, dataList = [], skillTag = false, skillExperienceEnabled = false,isSkillExperienceDisabledByDefault = false, isEducationList = false }) => {

    const [formData, setFormData] = useState(dataList || []);
    const [mapList, setMapList] = useState(dataList || []);
    const [selectedValue, setSelectedValue] = useState('Languages')
    // const [expandableTitle, setExpandableTitle] = useState([])


        useEffect(() => {
            let updatedFormData = formData;
            if (isSkill && !skillExperienceEnabled) {
                 updatedFormData = formData.map((item)=>{
                    item.level = ''
                    return item
                })
         
            } else{
                updatedFormData = formData.map((item)=>{
                    item.level = 'Beginner'
                    return item
                })
            }

            // customListFormData(updatedFormData)
            setFormData(updatedFormData)
        // eslint-disable-next-line
        }, [skillExperienceEnabled])


    const handleCustomAdd = () => {
        setMapList([...mapList, mapList.length]);
        const tempObj = {}
        addList.map((item) => {
            const { name } = item
            tempObj[name] = ''
            if (name === 'date') {
                tempObj.startDate = ''
                tempObj.endDate = ''
                // eslint-disable-next-line
                return;
            }
            if (name === 'tag') {
                tempObj.tag = selectedValue
            }
// eslint-disable-next-line
            return;
        })
        setFormData([...formData, { ...tempObj }]);
        // setExpandableTitle([...expandableTitle, ""])
    };



    const handleChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [name]: value,
        };
        customListFormData(updatedFormData)
        setFormData(updatedFormData);
    };

    const handleTextEditorChange = (val, index, inputName) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [inputName]: val,
        };
        customListFormData(updatedFormData)
        setFormData(updatedFormData);
    };

    const onDelete = (index) => {
        const updatedMapList = mapList.filter((_, i) => i !== index);
        const updatedFormData = formData.filter((_, i) => i !== index);
        setMapList(updatedMapList);
        customListFormData(updatedFormData)
        setFormData(updatedFormData);
    };

    const setDate = (date, index, inputName) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            [inputName]: date,
        };
        customListFormData(updatedFormData)
        setFormData(updatedFormData);
    }

    const getLevel = async (level, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            level: level,
        };
        customListFormData(updatedFormData)
        setFormData(updatedFormData);
    };

    const words = buttonLabel.split(" ");
    words.splice(1, 0, "one more");

    const newButtonLabel = words.join(" ");

    const handleSelectChange = (e, index) => {
        setSelectedValue(e.target.value)
        const updatedFormData = [...formData];

        updatedFormData[index] = {
            ...updatedFormData[index],
            tag: e.target.value,
        };
        customListFormData(updatedFormData)
        setFormData(updatedFormData);
    }

    return (
        <div>
            
            <label className="block text-[12px] font-medium text-gray-700 my-2">{label}</label>
            {mapList.map((item, index) => {
                let title = ''
                let subTitle = ''

                if (isSocialList || isProjectList || isCourseList) {
                    title = formData[index]?.[addList[0]?.name];
                    subTitle = formData[index]?.[addList[1]?.name] ? (isProjectList ? "Tech Stack: " : '') + formData[index]?.[addList[1]?.name] : ''
                } else if (isSkill) {
                    title = formData[index]?.[addList[0]?.name];
                } else {
                    title = formData[index]?.[addList[0]?.name];
                    title += title !== '' && formData[index]?.[addList[1]?.name] !== '' ? ' at ' + formData[index]?.[addList[1]?.name] : formData[index]?.[addList[1]?.name];
                }


                let date = '';
                if (formData[index]?.["startDate"] !== undefined && formData[index]?.["endDate"] !== undefined) {
                    date = formData[index]?.["startDate"];
                    date += date !== '' && formData[index]?.['endDate'] !== '' ? ' - ' + formData[index]?.['endDate'] : formData[index]?.['endDate'];
                }

                return (
                    <div key={index}>
                        <ExpandableContainer
                            open
                            title={title !== '' ? title : '(Not Specified)'}
                            date={date}
                            subTitle={subTitle}
                            onDelete={() => onDelete(index)}
                        >
                            <form className="grid grid-cols-2 gap-4">
                                {
                                    addList.length > 0 && addList.map((item) => {
                                        const { name, label, inputType } = item;
                                        let intialStartdate = new Date();
                                        let initialEnddate = new Date();
                                        if (inputType === "dateTime") {
                                            if (formData[index]?.startDate) {
                                                const dateString = formData[index]?.startDate;
                                                const [month, year] = dateString.split("/");
                                                const dateObject = new Date(year, month - 1);
                                                intialStartdate = dateObject
                                            }

                                            if (formData[index]?.endDate && formData[index]?.endDate !== "Present") {
                                                const dateString = formData[index]?.endDate;
                                                const [month, year] = dateString.split("/");
                                                const dateObject = new Date(year, month - 1);
                                                initialEnddate = dateObject
                                            }
                                        }
                                        return <>
                                            {inputType === 'text' && <TextBox
                                                label={label}
                                                type="text"
                                                inputName={name}
                                                onChange={(e) => handleChange(e, index, formData[index]?.tag)}
                                                inputValue={formData[index]?.[name] || ''}
                                            />}
                                            {inputType === 'levelIndicator' && <RatingPicker levelLabel={formData[index]?.level} skillEnabled={skillExperienceEnabled}
                                                getLevel={(level, inputName) =>
                                                    getLevel(level, index, inputName, formData[index]?.tag)
                                                } />}

                                            {inputType === 'dateTime' && <DateTimePicker
                                                label={label}
                                                setDate={(date, inputName) => setDate(date, index, inputName)}
                                                isEducationList={isEducationList}
                                                intialStartdate={intialStartdate}
                                                initialEnddate={formData[index]?.endDate !== "Present" ? initialEnddate : formData[index]?.endDate}
                                            />}



                                            {inputType === 'textBox' && <div className="col-span-2">
                                                <TextEditor
                                                    label={label}
                                                    placeholder="e.g. Developed and maintained web applications using JavaScript and Python."
                                                    onChange={(val) => handleTextEditorChange(val, index, 'desc')}
                                                    inputValue={formData[index]?.[name] || ''}
                                                />
                                            </div>}
                                            {inputType === 'selectOption' && <div>
                                                <select value={formData[index]?.tag} onChange={(e) => handleSelectChange(e, index)} className='mt-1 block bg-white w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-base'>
                                                    <option value="Languages">Languages</option>
                                                    <option value="Tools">Tools</option>


                                                    <option value="Framework & Library">Framework & Library</option>

                                                    <option value="Technologies">Technologies</option>

                                                </select>
                                            </div>}
                                        </>

                                    })

                                }

                            </form>
                        </ExpandableContainer>
                    </div>
                )
            })}
            {formData.length === 0 ? (
                <div
                    onClick={handleCustomAdd}
                    className="cursor-pointer text-sm font-semibold text-blue-500 hover:text-blue-600"
                >
                    + {buttonLabel}
                </div>
            ) : (
                <div
                    onClick={handleCustomAdd}
                    className="cursor-pointer text-sm font-semibold text-blue-500 hover:text-blue-600"
                >
                    + {newButtonLabel}
                </div>
            )}
        </div>
    );
};

export default CustomAddList;